"use client";

import React from 'react';
//import { useState, useEffect } from 'react';
//import { motion, AnimatePresence } from 'framer-motion';
import { Routes, Route } from 'react-router-dom';

import Login from './pages/Login';
import MainPage from './pages/MainPage';
import OAuthCallback from './pages/OAuthCallback';
import TextElementQuickActionsPage from './pages/TextElementQuickActionsPage';
import SiteBriefsPage from './pages/SiteBriefsPage';
import SiteBriefChatPage from './pages/SiteBriefChatPage';

import { RealtimeProvider } from './realtime';

import PrivateRoute from './PrivateRoute';
import { AuthProvider } from './AuthContext';

import { SessionProvider } from './components/SessionDropdown';
import { LanguageProvider } from './components/LanguageDropdown';

import './styles/animations.css';
import './styles/custom-scrollbar.css';
import './styles/mobile.css';

const App: React.FC = () => (
  <AuthProvider>
    <RealtimeProvider><LanguageProvider>
      <SessionProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />
          <Route path="/" element={<PrivateRoute><MainPage /></PrivateRoute>} />
          <Route path="/text-quick-actions" element={<PrivateRoute><TextElementQuickActionsPage /></PrivateRoute>} />
          <Route path="/site-briefs" element={<PrivateRoute><SiteBriefsPage /></PrivateRoute>} />
          <Route path="/site-builder" element={<PrivateRoute><SiteBriefChatPage /></PrivateRoute>} />
        </Routes>
      </SessionProvider>
    </LanguageProvider></RealtimeProvider>
  </AuthProvider>
);

export default App;
